<template>
  <div class="login">
    <div class="login-panel">
      <div class="logo-panel">
        <span class="custor-pointer" @click="goTo('/')">
          <img src="../../static/images/logo_blue.png" alt="Logo" />
        </span>
      </div>
      <div class="login-body">
        <Input type="text" v-model="phone" placeholder="请输入用户名" />
        <Input
          type="password"
          class="margin-top"
          v-model="password"
          placeholder="请输入密码"
        />
        <div class="icon user"></div>
        <div class="icon lock"></div>
      </div>
      <div class="login-footer">
        <Button
          size="large"
          type="primary"
          long
          shape="circle"
          :loading="modal_loading"
          @click="login()"
          >登录</Button
        >
      </div>
    </div>
    <!-- <Modal v-model="loginModal" width="360" :closable="false" :mask-closable="false">
      <div>
        <h2 style="margin:10px;color:#abcdef;text-align:center">
          <img :src="logo" alt height="50">
        </h2>
        <Input placeholder="请输入姓名" v-model="phone"></Input>
        <Input class="mar-top-10" type="password" v-model="password" placeholder="请输入密码"></Input>
      </div>
      <div slot="footer">
        <Button size="large" long :loading="modal_loading" @click="login()">登录</Button>
        <small style="text-align: center;display:block" class="mar-top-10">©copyright by 地图无忧</small>
      </div>
    </Modal> -->
  </div>
</template>
<script>
import "../assets/stylesheets/login.scss";
import getData from "../service/getData";
import api from "../service/api";
// import Cookies from "js-cookie";
export default {
  data() {
    return {
      phone: "",
      password: "",
      loginModal: true,
      modal_loading: false
    };
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    login: async function() {
      console.log(this.phone);
      console.log(this.password);
      const res = await getData.post(api.demoLogin, {
        phone: this.phone,
        password: this.password
      });
      if (res.data && res.data.status) {
        sessionStorage.setItem("userId", res.data.user.uuid);
        sessionStorage.setItem("nickname", res.data.user.nickname);

        this.$router.push({ path: "/field-map" });
      } else {
        this.$Message.info(res.data.msg);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.mar-top-10 {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/DemoLogin.vue